module.exports = __webpack_public_path__ + "static/media/art69.274ab2e7.jpg";